import { Box, Paper } from '@material-ui/core'
import Alert from '@mui/material/Alert'

export const AlertComponent = (props) => {
  const { copro, selectedItem, sx } = props

  if (selectedItem.id === 'Accueil') {
    return null
  }

  return (
    <Box component={Paper} sx={{ mb: '10px', ...sx }}>
      <Alert severity="info">{selectedItem.description}</Alert>
    </Box>
  )
}
export default AlertComponent
